import { FormattedMessage } from 'react-intl';
import { PeriodDateRange } from '@/components/PeriodDateRange';
import { WarningBanner } from '../core/WarningBanner';
import type { CollectionTicketClaimDTO } from '@/api/trafikportalen';

interface PeriodOverlapWarningProps {
  overlapping: CollectionTicketClaimDTO[];
  className?: string;
}

export const PeriodOverlapWarning = ({
  overlapping,
  className,
}: PeriodOverlapWarningProps) => {
  if (overlapping.length === 0) return null;

  const ranges = overlapping.map((claim, index) => (
    <span key={claim.id}>
      {index > 0 ? ', ' : null}
      <PeriodDateRange from={claim.valid_from} to={claim.valid_to} />
    </span>
  ));

  return (
    <WarningBanner className={className}>
      <FormattedMessage
        defaultMessage="Perioden överlappar {count, plural, one {en befintlig period} other {befintliga perioder}}: {ranges}. Elever kan få biljetter från flera perioder samtidigt."
        values={{ count: overlapping.length, ranges }}
      />
    </WarningBanner>
  );
};
